module.exports = __webpack_public_path__ + "img/aesolar.092e99a4.png";